<template>
  <action-dispatcher
    action="membersSetup/getFAQs"
    :parameters="$route.params.id"
  >
    <div class="product-details-content-setup-step-05">
      <div class="mb-5">
        <step-title
          title="FAQ"
          description="Configure O FAQ (Perguntas mais frequentes) para o seus alunos."
          icon="icon-question"
        />
      </div>

      <draggable v-model="sortedQuestions" handle=".handle" group="questions">
        <question-item
          v-for="(question, i) in sortedQuestions"
          :key="`q-${i}`"
          :item="question"
          @remove="remove"
          @update="refresh"
          :index="i"
        />
      </draggable>

      <div class="mb-3"></div>

      <div
        v-if="!sortedQuestions.length"
        class="container centralize-row text-center pt-5 mb-6"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-5 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não cadastrou nenhuma pergunta</h5>
            <small class="text-secondary mb-5">
              Clique no botão abaixo para cadastrar
            </small>
          </div>
        </div>
      </div>

      <button-add-question @click="add" />
    </div>
  </action-dispatcher>
</template>

<script>
import ButtonAddQuestion from "@/components/ButtonAddQuestion";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import QuestionItem from "./faq/QuestionItem";

export default {
  components: { draggable, QuestionItem, ButtonAddQuestion },
  computed: {
    ...mapState("membersSetup", ["faqs"]),
    sortedQuestions: {
      get() {
        return [...this.faqs].sort((a, b) => a.sort - b.sort);
      },
      set(value) {
        const faqs = [...this.faqs];
        for (let i in faqs) {
          for (let j in value) {
            if (faqs[i].id === value[j].id) {
              faqs[i].sort = j;
            }
          }
        }
        this.saveOrder(faqs);
      }
    }
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("membersSetup/getFAQs", this.$route.params.id);
    },
    async saveOrder(newFaqs) {
      const error_index = undefined;
      for (let i in newFaqs) {
        try {
          const payload = { ...newFaqs[i] };
          if (payload.company_id) {
            delete payload.company_id; // fix backend primary key error
          }
          await this.$store.dispatch("membersSetup/putFAQ", payload);
        } catch (e) {
          error_index = i;
        }
      }

      if (error_index) {
        this.$message.error(
          `Não foi possível salvar a pergunta ${error_index + 1}`
        );

        return;
      }

      this.refresh();
    },
    add() {
      this.$store.commit("membersSetup/setFaqs", [
        ...this.faqs,
        {
          question: "",
          answer: ""
        }
      ]);
    },
    remove(index) {
      this.$store.commit(
        "membersSetup/setFaqs",
        this.faqs.filter((_, i) => i !== index)
      );
    }
  }
};
</script>
